import { useState } from "react";
import axios from "axios";

const C = {
  navy: "#1B3A6B",
  gold: "#C8A951",
  white: "#FFFFFF",
  lightGray: "#F7F7F7",
  border: "#E0E0E0",
  subtext: "#666",
};

export default function Chat() {
  const [messages, setMessages] = useState([
    { role: "assistant", text: "שלום! אני עסק חכם. איך אוכל לעזור לך היום?" }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;
    const question = input;
    setInput("");
    setMessages(prev => [...prev, { role: "user", text: question }]);
    setLoading(true);
    try {
      const pw = sessionStorage.getItem("dekel_pw") || "";
      const res = await axios.post(
        `https://bi.dekelltd.com/api/ask?question=${encodeURIComponent(question)}`,
        {},
        { headers: { "X-Dashboard-Password": pw } }
      );
      setMessages(prev => [...prev, { role: "assistant", text: res.data.answer }]);
    } catch {
      setMessages(prev => [...prev, { role: "assistant", text: "שגיאה – נסה שוב" }]);
    }
    setLoading(false);
  };

  return (
    <div style={{ maxWidth: 720, margin: "0 auto" }}>
      <div style={{ background: C.white, borderRadius: 14, border: `1px solid ${C.border}`, boxShadow: "0 2px 12px rgba(0,0,0,0.07)", overflow: "hidden" }}>
        {/* Messages */}
        <div style={{ padding: 20, minHeight: 420, maxHeight: 540, overflowY: "auto" }}>
          {messages.map((m, i) => (
            <div key={i} style={{ display: "flex", justifyContent: m.role === "user" ? "flex-start" : "flex-end", marginBottom: 12 }}>
              <div style={{
                background: m.role === "user" ? C.navy : C.lightGray,
                color: m.role === "user" ? C.white : "#2C2C2C",
                borderRadius: m.role === "user" ? "14px 14px 4px 14px" : "14px 14px 14px 4px",
                padding: "10px 16px",
                maxWidth: "78%",
                fontSize: 15,
                lineHeight: 1.65,
                whiteSpace: "pre-wrap",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
              }}>
                {m.text}
              </div>
            </div>
          ))}
          {loading && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div style={{ background: C.lightGray, borderRadius: 14, padding: "10px 16px", color: C.subtext, fontSize: 14 }}>
                חושב...
              </div>
            </div>
          )}
        </div>

        {/* Input */}
        <div style={{ borderTop: `1px solid ${C.border}`, padding: 14, display: "flex", gap: 10, background: C.white }}>
          <button onClick={sendMessage} style={{
            background: C.navy, color: C.white, border: "none",
            borderRadius: 8, padding: "10px 22px", cursor: "pointer",
            fontSize: 15, fontWeight: "bold", whiteSpace: "nowrap",
          }}>שלח</button>
          <input
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => e.key === "Enter" && sendMessage()}
            placeholder="שאל שאלה עסקית..."
            style={{
              flex: 1, borderRadius: 8, border: `1px solid ${C.border}`,
              padding: "10px 14px", fontSize: 15, direction: "rtl",
              outline: "none",
            }}
          />
        </div>
      </div>
    </div>
  );
}
